<span class="spinner-container relative" [style.width]="$size()">
  <span class="spinner" [style.borderWidth]="$borderWidth()" [style.borderTopColor]="'var(' + $color() + ')'"></span>
</span>
